'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/LocationCard.js');
require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
var SelectList = require('../../../components/SelectList/SelectList.js');
var ErrorBanner = require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
require('../../../components/SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var language_en_US = require('../../../consts/language_en_US.js');
var ReturnsConfigProvider = require('../../../providers/ReturnsConfigProvider.js');
var LanguageProvider = require('../../../providers/LanguageProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ZERO_VALUE = 0;
const tempLanguageKeys = {
  returnsReasonsQuantityAllError: language_en_US["default"].returnsReasonsQuantityAllError,
  returnsReasonsQuantityAllTitle: language_en_US["default"].returnsReasonsQuantityAllTitle,
  returnsReasonsQuantityAllTitleHipaa: language_en_US["default"].returnsReasonsQuantityAllTitleHipaa,
  returnsReasonsQuantityAllYesLabel: language_en_US["default"].returnsReasonsQuantityAllYesLabel,
  returnsReasonsQuantityAllNoLabel: language_en_US["default"].returnsReasonsQuantityAllNoLabel
};
const ReturnReasonsQuantityAll = _ref => {
  let {
    onChange,
    totalQuantity
  } = _ref;
  const {
    isHipaaCompliant
  } = ReturnsConfigProvider.useReturnsConfig();
  const [selection, setSelection] = React.useState(null);
  const [isErrorShown, setErrorShown] = React.useState(false);
  const {
    returnsReasonsQuantityAllError,
    returnsReasonsQuantityAllTitle,
    returnsReasonsQuantityAllTitleHipaa,
    returnsReasonsQuantityAllYesLabel,
    returnsReasonsQuantityAllNoLabel
  } = nthHookTranslations.useTranslations();
  if (!totalQuantity) return null;
  const handleChange = e => {
    // set the selected value
    setSelection(e);

    // make sure the value is of type number
    const valueAsNumber = Number.parseInt(e, 10);

    // if the value is 0, we show the error and return early
    if (valueAsNumber === ZERO_VALUE) {
      setErrorShown(true);
      return;
    } else {
      setErrorShown(false);
    }

    // if the value is not zero, we set the quantity and proceed to the next step via the parent component's onChange
    onChange(Number.parseInt(e, 10));
  };
  const langKeySuffix = isHipaaCompliant ? 'Hipaa' : '';
  return /*#__PURE__*/React__default["default"].createElement(LanguageProvider.LanguageProvider, {
    language: {
      returnsReasonsQuantityAllError: returnsReasonsQuantityAllError ?? tempLanguageKeys.returnsReasonsQuantityAllError,
      returnsReasonsQuantityAllTitle: returnsReasonsQuantityAllTitle ?? tempLanguageKeys.returnsReasonsQuantityAllTitle,
      returnsReasonsQuantityAllTitleHipaa: returnsReasonsQuantityAllTitleHipaa ?? tempLanguageKeys.returnsReasonsQuantityAllTitleHipaa
    }
  }, isErrorShown && /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsQuantityAllError",
    defaultString: tempLanguageKeys.returnsReasonsQuantityAllError
  })), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsReasonsQuantityAllTitle${langKeySuffix}`,
    defaultString: isHipaaCompliant ? tempLanguageKeys.returnsReasonsQuantityAllTitleHipaa : tempLanguageKeys.returnsReasonsQuantityAllTitle
  })), /*#__PURE__*/React__default["default"].createElement(SelectList["default"], {
    onChange: handleChange,
    options: [{
      value: totalQuantity.toString(),
      label: returnsReasonsQuantityAllYesLabel ?? tempLanguageKeys.returnsReasonsQuantityAllYesLabel
    }, {
      value: ZERO_VALUE.toString(),
      label: returnsReasonsQuantityAllNoLabel ?? tempLanguageKeys.returnsReasonsQuantityAllNoLabel
    }],
    selection: selection
  }));
};

exports["default"] = ReturnReasonsQuantityAll;
